import React from 'react';
import { CheckoutButton, LeafDivider, Section } from './Shared';
import { offer } from '../data/offer';
export function ClosingCta() {
  return <Section className="max-w-3xl text-center" data-id="element-25" data-mp="10697siiwjuot">
      <h2 className="text-[28px] md:text-5xl font-display font-bold leading-tight text-brand-purpleDark" data-id="element-26" data-mp="l86z5tx0kj0p">
        🌱 Tu próxima consulta puede empezar con más orden
      </h2>
      <div className="mt-6 space-y-4 text-base md:text-lg text-brand-text leading-relaxed" data-id="element-27" data-mp="1dwcl2jzt0e24">
        <p data-id="element-28" data-mp="1dyp3ey9h4qfp">
          Tu conocimiento, tus observaciones y tu experiencia son el centro de
          tu trabajo.
        </p>
        <p data-id="element-29" data-mp="1472sz44ymve0">
          Saberes Ancestrales™ te ofrece una biblioteca para acompañarlos:
          plantas, preparaciones y herramientas de seguimiento reunidas en un
          solo pack.
        </p>
      </div>

      <LeafDivider data-id="element-30" data-mp="1wuymjzz8g76k" />

      <p className="text-sm md:text-base font-medium text-brand-purpleDark" data-id="element-31" data-mp="1wuf6ypx21uvp">
        5 volúmenes + 3 bonus · 405 páginas en PDF
      </p>
      <p className="mt-2 font-serif text-xl md:text-2xl text-brand-purpleDark" data-id="element-32" data-mp="21nruewpzzvmv">
        <span className="text-lg md:text-xl text-brand-text/45 line-through align-middle mr-2" data-id="element-33" data-mp="1k3kbbg368n55">
          {offer.originalPrice}
        </span>
        <span className="font-bold text-4xl md:text-5xl text-brand-purple align-middle" data-id="element-34" data-mp="1ttm06a3cm9l4">
          {offer.price}
        </span>{' '}
        · Pago único
      </p>

      <CheckoutButton className="mt-7 w-full sm:w-auto" data-id="element-35" data-mp="1p0are3ez7iqk">
        → QUIERO MI MEGAPACK SABERES ANCESTRALES
      </CheckoutButton>

      <p className="mt-4 text-sm text-brand-muted" data-id="element-36" data-mp="1xuxqyixyl0uw">
        Garantía de siete días · Para consultar en pantalla o imprimir
      </p>
    </Section>;
}